export default "__VITE_ASSET__FYXJ8nNA__"